module.exports = {
    // 请帮我把""或者``里的文字翻译成韩语, 其他文字不需要改动按原样返回, 不需要做其他回复 
    language: "한국인",
    xtc: {
        agreement: "구매는 {service} 및 {privacy}에 동의한 것으로 간주됩니다",
        service: "서비스 약관",
        privacy: "개인정보 정책",
        agreementAlert: "먼저 서비스 약관 및 개인정보 정책에 동의해 주세요.",
        pro: "회원 전용 혜택",
        proDesc: "회원은 무제한 대화를 즐기며 번역 기능을 사용할 수 있습니다",
        image: "최대 3장의 이미지를 업로드할 수 있습니다",
    },
    setting: {
        index: {
            title: "설정",
            problem: "문제 피드백",
            order: "주문 기록",
            notice: "공지",
            language: "언어",
            clear: "캐시 지우기",
            clearTip: "캐시를 지우시겠습니까?\n",
            confirm: "확인",
            cancel: "취소",
        },
        language: {
            title: "언어",
            langList: ["중문 간체", "중문 번체", "영어", "아랍어", "폴란드어", "페르시아어", "덴마크어", "독일어", "러시아어", "프랑스어", "네덜란드어", "체코어", "루마니아어", "포르투갈어", "일본어", "태국어", "터키어", "스페인어", "그리스어", "이탈리아어", "베트남어", "힌디어", "한국어", "인도네시아어", "말레이어", "벵골어", "히브리어", "우크라이나어", "크메르어", "슬로바키아어", "헝가리어", "슬로베니아어", "불가리아어", "크로아티아어"],
        },
        order: {
            title: "주문 기록",
            success: "가져오기 성공",
            unpaid: "미결제",
            paid: "결제됨",
            expired: "만료됨",
            refunded: "환불됨",
            review: "검토 중",
            failed: "환불 실패",
            payFailed: "결제 실패",
            pTime: "결제 시간",
            eTime: "만료 시간",
            pMethod: "결제 방법",
            pObject: "결제 대상",
            oNumber: "주문 번호",
            pType: "패키지 유형",
            oTime: "획득 시간",
            watch: "IMEI 보기",
            delete: "주문 삭제",
            refund: "환불 요청",
            invoice: "청구서",
            empty: "아직 기록 없음",
            grade: "패키지 레벨",
            package: "패키지 상태",
            use: "사용 상태",
            remaining: "패키지 수량",
            basic: "베이식",
            pro: "프로",
            refundAmount: "환불 금액",
        },
        invoice: {
            invoice: "Jarvis 청구서",
            download: "청구서 다운로드",
            from: "보낸 사람",
            to: "받는 사람",
            memo: "메모",
            thank: "이용해 주셔서 감사합니다!",
            draft: "견본",
            amount: "결제 금액",
        },
        problem: {
            title: "문제 피드백",
            feedback: "피드백 유형",
            please: "선택해주세요",
            content: "내용",
            improve: "기능 요구, 제품 불만 등 제안을 적어주세요. 더 나은 개선을 위해 노력하겠습니다.",
            upload: "이미지 업로드",
            submit: "제출",
            general: "일반 피드백",
            purchase: "구매 관련",
            bug: "버그 신고",
            suggestion: "제안",
            other: "기타",
        },
        notice: {
            title: "공지",
            type: "알림 유형: 시스템 회신",
            time: "알림 시간: "
        }
    },
    subscription: {
        jarvis: {
            funcList: ["AI Q&A", "AI 그림 그리기", "기본 버전 스마트 AI", "고급 스마트 AI", "멀티모달 입출력", "더 자세한 Q&A", "더 똑똑한 모델", "더 빠른 응답"],
            times: "회",
            days: "일",
            more: "더 고급 AI",
            custom: "맞춤형 워치 스마트 AI 목록",
            delay: "계정에 충전 반영에 약간의 지연이 있을 수 있습니다. 잠시 기다렸다가 워치 앱을 종료 후 재진입해주세요.",
            member: "멤버십 비교",
            packageName: "패키지 이름",
            unlimited: "무제한",
            month: "월",
            paySuccess: "결제 성공",
        },
        index: {
            nav: {
                l: "프로",
                r: "횟수",
                language: "언어",
                notice: "공지",
                feedback: "피드백",
            },
            proBox: {
                expire: {
                    title: "만료일",
                    date: "아직 구독하지 않음",
                },
                packTip: "세 가지 월별 패키지가 있습니다",
                packList: ["슈프림 구독", "베이식 구독", "일반 구독"],
                benefit: {
                    origin: "정가: ",
                    remaining: "잔여",
                    title: "구독 혜택",
                    value: "가치",
                    benefitList: [
                        { labelTime: "무제한 횟수", labelSave: "사진 저장", labelPer: "전체 권한" },
                        { labelTime: "300회", labelSave: "기록 저장", labelPer: "기본 권한" },
                        { labelTime: "100회", labelSave: "기록 저장", labelPer: "낮은 권한" },
                    ],
                    desc: "$3.99/월은 100회 무료 사용, $9.99/월은 300회 무료 사용이 포함됩니다.",
                    tip: "계정에 횟수가 반영되기까지 약간의 지연이 있을 수 있습니다. 잠시 기다렸다가 워치 앱을 종료 후 재진입해주세요."
                },
            },
            timeBox: {
                packTip: "세 가지 월별 패키지가 있습니다",
                packList: ["신규 사용자 할인 횟수 패키지", "50회 패키지", "100회 패키지", "300회 패키지"],
                times: {
                    title: "횟수의 역할",
                    timesList: ["그림 그리기에 사용", "GPT Q&A에 사용", "별자리 점술에 사용", "학습에 사용", "사물 인식에 사용"],
                    desc: "50회 $2.99, 100회 $4.99, 300회 $12.99. $0.99의 50회 패키지는 신규 사용자용으로 1회만 구매 가능(24시간 이내 유효)",
                }
            },
            staticBox: {
                confirm: "확인",
                privacy: "개인정보",
                terms: "약관",
                refund: "환불",
                cancel: "언제든 취소 가능",
                funcTitle: "PRO 경험으로 창의력을 해방하세요",
                function: "기능",
                free: "무료",
                pro: "프로",
                funcList: ["횟수는 1일간 유효", "10회 그림/채팅(3회 활성화 기회)", "한 번 구독 시 30일", "더 많은 사용 횟수", "사진 영구 보관", "구매 가능한 횟수"],
                details: "자세히",
            },
            dialog: {
                error: "결제 불가. 워치의 QR 코드를 스캔해주세요.",
                unbind: "결제 계정을 변경 중입니다. 계속하시겠습니까?",
                beforePay: "현재 계정으로 결제를 계속하시겠습니까",
                renewal: "자동 갱신을 활성화하시겠습니까",
                confirm: "확인",
                cancel: "취소",
                change: "변경/연동",
                beforeConsent: "해당 상품을 구독 중입니다",
            }
        },
        NewIndex: {
            l: "베이식",
            r: "프로",
            proBox: {
                benefit: {
                    title: "패키지 포함 사항",
                    benefitList: [
                        { labelTime: "획득 횟수", labelSave: "일반 횟수" },
                        { labelTime: "획득 횟수", labelSave: "프로 횟수" },
                        { labelTime: "기능 잠금 해제", labelSave: "모든 일반 기능 잠금 해제" },
                        { labelTime: "기능 잠금 해제", labelSave: "모든 프리미엄 기능 잠금 해제" },

                    ]
                }
            },
            funcList: ["Q&A", "AI 그림 그리기", "기본 버전 스마트 AI", "고급 스마트 AI", "텍스트 음성 변환", "더 자세한 답변", "더 빠른 응답"],
            confirm: '지금 업그레이드',
            dialog: {
                beforePay: "일반 회원을 구독 중입니다. 프리미엄 회원을 추가 구매하면 일반 회원의 실제 사용량에 따라 환불됩니다. 계속하시겠습니까?",
            },
            licenseBox: {
                navTitle: "업그레이드 패키지 구매",
                title: "업그레이드 패키지 특권",
                func: [
                    {
                        label: "횟수 획득",
                        value: "획득 가능",
                        value2: "회 고급 사용량"
                    },
                    {
                        label: "기능 잠금 해제",
                        value: "고급 사용은 모든 고급 기능에 접근 가능"
                    },
                    {
                        label: "공유 사용",
                        value: "고급 모드 활성화 후 모든 기능이 고급 사용량 공유"
                    },
                ],
                funLevel: {
                    title: "기능 업그레이드",
                    funs: [
                        {
                            label: "답변 최적화",
                            value: "답변 품질 향상, 응답 속도 증가, 답변 글자 수 한도 상향"
                        },
                        {
                            label: "사진 인식",
                            value: "사진 인식 권한 해제, 사진 인식 기능 사용 가능"
                        },
                        {
                            label: "텍스트 음성 변환",
                            value: "TTS 권한 해제, 답변 텍스트 오디오 재생 가능"
                        }
                    ]
                }
            }
        },
        zw: {
            member: "멤버십 구매",
            min: "분",
            expire: "유효기간: {0}일",
        },
        qw: {
            func: "기능 소개",
            func1: "초장시간 분 단위!",
            func2: "2시간 회의 지원!",
            func3: "원클릭 회의록 생성!",
            func4: "지능형 챕터 분할!",
            func5: "할 일 항목 지능형 추출!",
            func6: "원클릭 마인드맵 생성!",
            func7: "여러 형식으로 회의 내보내기!",
            buy: "지금 구매",
            pullUp: "결제가 완료되었습니다! 이제 {name}을 실행하고 더 많은 기능을 사용해 보세요.",
            tips: "이 제품은 구독 상품이며 기간 만료 시 자동으로 갱신됩니다",
            paymentFailed: "결제 실패",
            unsubscribeSuccess: "구독 취소 성공.",
            effectiveOrder: "유효 주문",
            expireOrder: "만료된 주문",
            submitSuccess: "제출 성공.",
            emailError: "유효하지 않은 이메일 형식입니다.",
            payTimeout: "주문 페이지로 이동해 주세요.",
            confirmText: "확인하면 HONG KONG ADFLASH MEDIA LIMITED가 해당 약관에 따라 이 카드에서 현재 및 향후 결제를 청구하는 것에 동의하게 됩니다."
        },
        unsubscribe: {
            title: "구독 취소",
            subTitle: "연속 구독",
            unsubscribe: "구독 해지",
            subscribeTime: "구독 시간",
            cardBind: "카드 연동 성공",
            cardBindDesc: "결제 계정이 성공적으로 추가되었습니다",
            empty: "구독 기록 없음",
        },
        refund: {
            title: "환불 요청",
            number: "주문 번호",
            content: "환불 사유를 설명해주세요",
            empty: "제출할 수 없습니다. 필수 항목이 비어 있습니다.",
        },
        order: {
            number: "주문 번호",
            name: "주문 이름",
            times: "주문 횟수",
            validity: "횟수 유효기간",
            buy: "지금 구매",
            days: "일",
            unlock: "모든 스마트 AI 잠금 해제",
            text: "텍스트 음성 변환",
            tips: "이 제품은 구독 상품입니다. 구매 후 기본적으로 구독이 시작됩니다.",
        },
        zhzn: {
            l: "그림",
            r: "Q&A",
            isCard: "결제 계정을 연동해주세요",
            subscription: "현재 상품은 구독형 상품입니다",
            title: "멤버십 특권",
            t1: "음성 인식",
            d1: "음성을 텍스트로 변환하여 편리하고 효율적인 소통 제공.",
            t2: "무제한 이미지 생성",
            d2: "무제한 이미지 생성으로 경계 없는 창의성, 빠르고 편리.",
            t3: "워치 페이스 설정",
            d3: "워치 페이스를 커스터마이즈하여 시간과 정보를 개성 있게 표시.",
            t4: "온라인 검색",
            d4: "실시간으로 정보를 얻고 필요한 답을 빠르게 찾기.",
            t5: "정보 검색",
            d5: "빠르게 검색하고 정확한 정보와 답변 제공.",
        }
    },
    payment: {
        index: {
            contact: "연락처",
            please: "이메일 주소를 입력하세요",
            email: "결제 영수증이 이 이메일로 전송됩니다",
            name: "카드 명의자 이름",
            firstName: "이름",
            lastName: "성",
            confidence: "당사는 귀하의 정보를 저장하지 않습니다. 안심하고 입력해 주세요",
            Card: "카드 정보",
            confirm: "구독을 확인하면, 귀하는 약관에 따라 향후 결제를 위해 Jarvis가 귀하의 카드에서 금액을 청구하는 것에 동의하게 됩니다. 구독은 언제든 취소할 수 있습니다.",
            powered: "Stripe 제공",
            terms: "약관",
            privacy: "개인정보",
        }
    },
    policy: {
        title: {
            terms: "약관",
            about: "소개",
            service: "서비스 약관",
            privacy: "개인정보 처리방침",
            refund: "환불 정책",
            us: "회사 소개",
        },
        service: {
            section1: `<p>https://aiwatchstore.org/에 위치한 웹사이트는 HONG KONG ADFLASH MEDIA LIMITED의 저작권이 있는 작품입니다. 사이트의 특정 기능은 추가 가이드라인, 약관 또는 규칙의 적용을 받을 수 있으며, 해당 기능과 관련하여 사이트에 게시됩니다.</p>
            <p>모든 추가 약관, 가이드라인 및 규칙은 본 약관에 참조로 포함됩니다.</p>
            <p>본 이용 약관은 귀하의 사이트 사용을 규율하는 법적으로 구속력 있는 약관을 설명합니다. 사이트에 로그인함으로써 귀하는 본 약관에 동의하며, 본 약관에 동의할 권한과 능력이 있음을 진술합니다. 사이트에 접근하려면 최소 18세 이상이어야 합니다. 본 약관의 모든 조항에 동의하지 않으면 사이트에 로그인하거나 사용하지 마십시오.</p>
            <p>본 약관은 분쟁 발생 시 개인 단위의 중재(섹션 10.2)를 요구하며, 또한 분쟁 시 귀하에게 제공되는 구제 수단을 제한합니다.</p>
            <h2>사이트 접근</h2>
            <p><strong>본 약관에 따름.</strong> 당사는 귀하에게 개인적이고 비상업적인 사용을 위한 목적으로만 사이트에 접근할 수 있는 양도 불가, 비독점적, 철회 가능한 제한 라이선스를 부여합니다.</p>
            <p>당사는 통지 유무와 관계없이 사이트를 변경, 중단 또는 중지할 권리를 보유합니다. 귀하는 당사가 귀하 또는 제3자에게 사이트 또는 그 일부의 변경, 중단 또는 종료에 대해 책임을 지지 않음을 승인합니다.</p>
            <p><strong>지원 및 유지보수 없음.</strong> 당사는 사이트와 관련하여 어떠한 지원 의무도 지지 않음을 귀하는 동의합니다.</p>
            <p>귀하가 제공할 수 있는 사용자 콘텐츠를 제외하고, 사이트 및 그 콘텐츠의 모든 지식재산권(저작권, 특허, 상표권, 영업비밀 포함)은 당사 또는 당사 공급자에게 속합니다. 본 약관 및 사이트 접근은 섹션 2.1에 명시된 제한적 접근 권리를 제외하고 어떠한 권리, 소유권 또는 이익을 부여하지 않습니다. 당사와 공급자는 본 약관에서 부여되지 않은 모든 권리를 보유합니다.</p>`,
            section2: `<h2>구독 약관</h2>
            <p>당사의 구독 서비스(이하 “서비스”)에 오신 것을 환영합니다. 본 서비스는 HONG KONG ADFLASH MEDIA LIMITED(이하 “당사”)가 제공합니다. 서비스를 사용하거나 구독함으로써 귀하는 본 구독 약관(이하 “약관”)을 준수하는 데 동의합니다.</p>
            <p>당사는 구독 기반 서비스를 제공하며, 독점 사용자 할당량을 포함할 수 있습니다. 구체적인 서비스 제공 내용과 요금은 언제든 변경될 수 있으며 이메일 또는 웹사이트 공지를 통해 업데이트됩니다.</p>
            <p>구독 요금, 결제 방법 및 결제 주기는 요금제 페이지에 상세히 기재됩니다. 연체 계정은 유료 서비스가 일시 중단될 수 있습니다.</p>
            <p>모든 구독 요금은 법률에 의해 요구되거나 당사의 단독 재량이 아닌 한 환불되지 않습니다.</p>
            <p>귀하는 언제든 구독을 취소할 수 있습니다. 취소 시 현재 구독 기간 종료까지 서비스가 제공되며, 이미 지불한 요금은 환불되지 않습니다.</p>
            <p>다음과 같은 경우 당사는 귀하의 서비스를 일방적으로 종료 또는 중단할 권리를 보유합니다:</p>
            <p>- 본 약관 위반</p>
            <p>- 구독료 미지급</p>
            <p>당사는 고품질 서비스를 제공하기 위해 최선을 다하지만, 서비스의 가용성, 정확성 또는 완전성에 대해 명시적 또는 묵시적 보증을 하지 않습니다.</p>`,
            section3: `<h2>다른 사용자</h2>
            <p><strong>다른 사용자.</strong> 각 사이트 사용자는 자신의 사용자 콘텐츠에 전적으로 책임을 집니다. 당사는 사용자 콘텐츠를 통제하지 않으므로, 귀하는 사용자 콘텐츠에 대해 당사가 책임지지 않음을 인정하고 동의합니다. 귀하는 이러한 상호작용의 결과로 발생하는 손실 또는 손해에 대해 당사가 책임지지 않음을 동의합니다. 귀하와 다른 사용자 간 분쟁이 있는 경우, 당사는 개입 의무가 없습니다.</p>
            <p>귀하는 당사 및 당사의 임원, 직원, 대리인, 승계인 및 양수인을 과거, 현재 및 미래의 모든 분쟁, 청구, 논쟁, 권리, 의무, 책임, 소송 및 원인으로부터 면책하고 영구히 면제합니다. 캘리포니아 거주자인 경우, 다음의 캘리포니아 민법 1542조를 포기합니다: "일반 면책은 채권자가 면책을 실행할 당시 자신에게 유리하게 존재함을 알지 못하거나 의심하지 못한 청구에는 확장되지 않으며, 알았더라면 채무자와의 합의에 중대한 영향을 미쳤을 것이다."</p>
            <p><strong>쿠키와 웹 비콘.</strong> 다른 웹사이트와 마찬가지로 ‘쿠키’를 사용합니다. 쿠키는 방문자의 선호도, 방문자가 접근하거나 방문한 페이지 등의 정보를 저장합니다. 이 정보는 방문자의 브라우저 유형 및 기타 정보에 기반하여 웹페이지 콘텐츠를 맞춤화함으로써 사용자 경험을 최적화하는 데 사용됩니다.</p>
            <h2>면책조항</h2>
            <p>본 사이트는 “있는 그대로” 및 “가용한 상태로” 제공되며, 당사 및 공급자는 상품성, 특정 목적에의 적합성, 소유권, 평온한 사용, 정확성 또는 비침해성에 대한 모든 명시적, 묵시적 또는 법정 보증을 명시적으로 부인합니다. 당사와 공급자는 사이트가 귀하의 요구를 충족하거나, 중단 없이, 시기적절하게, 안전하게, 오류 없이 제공되거나, 정확하고 신뢰할 수 있으며, 바이러스 또는 유해 코드가 없고, 완전하며, 합법적이거나 안전함을 보장하지 않습니다. 적용 법률상 보증이 필요한 경우, 모든 보증의 기간은 최초 사용일부터 90일로 제한됩니다.</p>
            <p>일부 관할권에서는 묵시적 보증의 배제를 허용하지 않으므로 위 배제가 적용되지 않을 수 있습니다. 또한 묵시적 보증 기간 제한을 허용하지 않는 관할권도 있으므로 위 제한이 적용되지 않을 수 있습니다.</p>`,
            section4: `<h2>책임의 제한</h2>
            <p>법이 허용하는 최대 범위 내에서, 어떠한 경우에도 당사 또는 공급자는 본 약관 또는 사이트 사용 또는 사용 불능과 관련하여 발생하는 이익 손실, 데이터 손실, 대체 제품 조달 비용, 간접적, 결과적, 모범적, 우발적, 특별 또는 징벌적 손해에 대해, 그러한 손해의 가능성이 통지되었더라도, 귀하 또는 제3자에게 책임지지 않습니다. 사이트 접근 및 사용은 귀하의 재량과 위험에 따르며, 그로 인해 발생하는 기기 또는 컴퓨터 시스템 손상, 데이터 손실에 대해 전적으로 책임을 집니다.</p>
            <p>법이 허용하는 최대 범위 내에서, 여기에 달리 규정된 바와 관계없이, 본 계약과 관련하여 발생하는 손해에 대한 당사의 책임은 항상 미화 50달러를 한도로 합니다. 청구가 여러 개 존재하더라도 이 한도는 확대되지 않습니다. 귀하는 본 계약과 관련하여 공급자가 어떠한 책임도 지지 않음을 동의합니다.</p>
            <p>일부 관할권에서는 부수적 또는 결과적 손해에 대한 책임 제한 또는 배제를 허용하지 않으므로 위 제한 또는 배제가 적용되지 않을 수 있습니다.</p>
            <p><strong>기간 및 종료.</strong> 본 약관은 귀하가 사이트를 사용하는 동안 계속 유효합니다. 당사는 단독 재량으로 언제든지, 본 약관 위반 포함, 귀하의 사이트 사용 권한을 중단 또는 종료할 수 있습니다. 종료 시 귀하의 계정 및 사이트 접근 권한은 즉시 종료되며, 계정과 연결된 사용자 콘텐츠가 라이브 데이터베이스에서 삭제될 수 있습니다. 당사는 이에 대해 어떠한 책임도 지지 않습니다. 종료 이후에도 섹션 2~2.5, 섹션 3, 섹션 4~10은 계속 유효합니다.</p>
            <p></p>
            <p>면책. 귀하는 서비스 사용, 귀하의 콘텐츠, 서비스와 관련하여 개발하거나 제공하는 제품 또는 서비스, 본 약관 위반 또는 관련 법 위반으로 인해 발생하는 모든 청구, 손실, 비용(변호사 비용 포함)으로부터 당사 및 계열사, 직원들을 방어하고 면책하며 무해하게 할 것에 동의합니다.</p>
            <p>면책 고지. 서비스는 “있는 그대로” 제공됩니다. 법이 금지하지 않는 한, 당사 및 계열사와 라이선스 제공자는 상품성, 특정 목적 적합성, 만족 품질, 비침해, 평온한 사용 등 모든 보증을 부인합니다. 서비스가 중단 없이, 정확하거나 오류 없이 제공되거나, 어떤 콘텐츠도 안전하며 손실 또는 변경되지 않음을 보증하지 않습니다.</p>`,
            section5: `<h2>저작권 정책.</h2>
            <p>당사는 타인의 지식재산을 존중하며, 이용자에게도 동일한 존중을 요구합니다. 저작권법을 준수하기 위해 침해 자료의 삭제 및 반복 침해자의 계정 종료 정책을 채택했습니다. 사용자가 사이트를 통해 위법하게 저작권을 침해한다고 믿는 경우, 다음 정보를 포함한 서면 통지를 저작권 담당자에게 제공해야 합니다(17 U.S.C. § 512(c)):</p>
            <p>- 물리적 또는 전자 서명;</p>
            <p>- 침해되었다고 주장하는 저작물의 식별;</p>
            <p>- 삭제를 요청하는 침해 자료의 서비스상 위치 식별;</p>
            <p>- 자료 위치 확인에 충분한 정보;</p>
            <p>- 주소, 전화번호, 이메일 주소;</p>
            <p>- 이의 자료 사용이 권한 없음을 선의로 믿는다는 진술;</p>
            <p>- 통지 정보가 정확하며, 위증 시 처벌을 감수하고, 본인이 권리자이거나 권리자를 대리한다는 진술.</p>
            <p>또한 17 U.S.C. § 512(f)에 따라, 서면 통지에서 중대한 사실을 허위 진술하는 경우, 그로 인해 발생한 손해, 비용, 변호사 비용에 대해 책임을 질 수 있음을 유의하십시오.</p>`,
            section6: `<h2>일반</h2>
            <p>본 약관은 수시로 개정될 수 있으며, 중대한 변경 시 마지막으로 제공한 이메일로 통지하거나 사이트에 공지합니다. 최신 이메일 제공은 귀하의 책임입니다. 유효하지 않은 이메일로 발송되더라도 통지 효력이 있습니다. 변경은 이메일 발송 후 30일 또는 사이트 공지 후 30일 중 빠른 시점에 효력이 발생합니다. 신규 사용자는 즉시 적용됩니다. 변경 이후 사이트 지속 사용은 변경사항 인지 및 동의로 간주됩니다. 분쟁 해결: 본 중재 합의서를 주의 깊게 읽으십시오. 이는 귀하의 권리에 영향을 미치며, 의무적 구속력 있는 중재 및 집단 소송 포기를 포함합니다.</p>
            <p><strong>중재 합의의 적용.</strong> 비공식적 해결 또는 소액 재판으로 해결되지 않는 모든 청구와 분쟁은 개인 단위의 구속력 있는 중재로 해결됩니다. 별도 합의 없으면 모든 중재 절차는 영어로 진행됩니다. 본 합의는 귀하와 당사 및 그 계열사, 대리인, 직원, 전·후임자, 양수인, 승인/비승인 사용자에게 적용됩니다.</p>
            <p><strong>통지 요건 및 비공식 분쟁 해결.</strong> 중재 전, 당사자 일방은 분쟁의 성질과 청구 취지, 구제를 설명한 서면 통지를 상대방에 먼저 보내야 합니다. 통지 수령 후 30일 내 해결되지 않으면 중재를 시작할 수 있습니다. 합의 제안 금액은 판정 전까지 중재인에게 공개되지 않습니다.</p>
            <p><strong>중재 규칙.</strong> 중재는 AAA를 통해 개시합니다. AAA가 불가하면 대체 ADR 제공자를 합의 선택합니다. ADR 규칙이 본 약관과 충돌하지 않는 한 적용됩니다. AAA 소비자 중재 규칙은 adr.org에서 확인 가능합니다. 단일 중립 중재인이 진행합니다. 청구액이 1만 달러 미만인 경우, 비출석 중재로 해결할 수 있습니다. 1만 달러 이상인 경우 심리 여부는 규칙에 따릅니다. 심리는 귀하 거주지 100마일 이내에서 열립니다(미국 외 거주 시 별도 통지). 판정은 유효 관할 법원에 등기될 수 있습니다. 중재 전 당사가 제안한 금액보다 큰 판정을 받으면, 당사는 더 큰 금액 또는 $2,500 중 큰 금액을 지급합니다. 각 당사자는 자체 비용을 부담하고, ADR 비용은 균등 분담합니다.</p>
            <p><strong>비출석 중재 추가 규칙.</strong> 전화, 온라인 또는 서면만으로 진행할 수 있습니다. 당사자 합의 없는 한 대면 출석은 없습니다.</p>
            <p><strong>시효.</strong> 중재는 관련 시효 및 AAA 규칙의 기한 내에 개시되어야 합니다.</p>
            <p><strong>중재인의 권한.</strong> 중재인은 당사자 권리·책임을 판단하고, 사건 병합 없이 진행합니다. 금전적 손해 및 개인에게 가능한 비금전적 구제를 부여할 수 있습니다. 서면 판정을 내리며, 법원의 판사와 동일한 권한을 가집니다. 판정은 최종이며 구속력 있습니다.</p>
            <p><strong>배심 재판 포기.</strong> 당사자들은 법원 및 배심 재판 권리를 포기하고 중재를 선택합니다.</p>
            <p><strong>집단 소송 또는 병합 포기.</strong> 모든 청구와 분쟁은 개인 단위로만 중재 또는 소송될 수 있으며, 다른 고객의 청구와 병합될 수 없습니다.</p>
            <p><strong>비밀유지.</strong> 중재 절차의 모든 측면은 비밀입니다. 법이 요구하지 않는 한 비밀을 유지합니다.</p>`,
            section7: `<p><strong>분리가능성.</strong> 본 중재 합의의 일부가 무효 또는 집행 불능인 경우, 해당 부분만 분리되며 나머지는 계속 유효합니다.</p>
            <p><strong>권리 포기.</strong> 본 합의의 권리와 제한은 상대방이 포기할 수 있으나, 다른 부분에는 영향이 없습니다.</p>
            <p><strong>생존.</strong> 본 중재 합의는 관계 종료 후에도 유효합니다.</p>
            <p><strong>소액재판.</strong> 어느 당사자든 소액재판소에 제소할 수 있습니다.</p>
            <p><strong>긴급 구제.</strong> 어느 당사자든 중재 전 상태 유지를 위해 법원에 긴급 구제를 요청할 수 있습니다.</p>
            <p><strong>중재 제외 청구.</strong> 명예훼손, CFAA 위반, 특허·저작권·상표·영업비밀 침해 또는 탈취 청구는 중재 대상이 아닙니다.</p>
            <p>법원이 허용하는 경우, 당사자들은 캘리포니아 네덜란즈 카운티 내 법원의 인적 관할에 따릅니다.</p>
            <p>본 사이트는 미국 수출 통제법의 적용을 받을 수 있습니다. 귀하는 미국 수출법을 위반하여 기술 데이터를 수출·재수출·이전하지 않기로 동의합니다.</p>`,
            section8: `<p><strong>전자적 통신.</strong> 귀하와 당사 간 통신은 전자적 수단을 사용합니다. 귀하는 전자 형식의 통신 수신에 동의하며, 전자적으로 제공되는 모든 문서가 서면 요구를 충족함에 동의합니다.</p>
            <p><strong>완전한 합의.</strong> 본 약관은 사이트 사용에 관한 완전한 합의입니다. 권리 미행은 권리 포기로 간주되지 않습니다. 조항 제목은 편의를 위한 것이며 법적 효력은 없습니다. “포함”은 “제한 없이 포함”을 의미합니다. 조항이 무효인 경우, 법이 허용하는 최대한도로 수정된 것으로 봅니다. 귀하와 당사는 독립 계약자 관계이며 대리나 파트너가 아닙니다. 당사의 사전 서면 동의 없이 양도, 하도급, 위임, 이전할 수 없으며, 위반 시 무효입니다. 당사는 자유롭게 양도할 수 있습니다. 본 약관은 양수인에게도 구속됩니다.</p>
            <p><strong>개인정보.</strong> 당사의 개인정보 처리방침을 읽어주세요.</p>
            <p><strong>저작권/상표.</strong> 저작권 ©. 무단 복제 금지. 사이트의 상표, 로고, 서비스 마크는 당사 또는 제3자의 자산입니다. 사전 서면 동의 없이 사용할 수 없습니다.</p>
            <h2>연락처</h2>
            <p>이메일: watch_support@adflash.cn</p>`
        },
        privacy: {
            section1: `        <p>귀하의 개인정보 보호는 중요합니다. 아래 성명서는 인터넷을 통해 때때로 제공될 수 있는 개인 식별 정보를 당사가 어떻게 처리하는지 이해하는 데 도움이 됩니다.</p>
            <p>당사 앱 및 관련 서비스에 기반하여, 제3자가 제공하는 특수 기능 서비스를 신청할 수 있습니다. 해당 서비스를 사용하려면 해당 서비스 약관을 주의 깊게 읽으십시오. 특수 기능 서비스를 수락하거나 사용함으로써, 귀하는 본 약관과 해당 서비스 약관을 읽고 동의하며 구속받는 데 동의합니다.</p>
            <p>요청하신 서비스를 제공하기 위해 때때로 정보가 필요할 수 있으며, 본 개인정보 보호 성명은 해당 제품에 적용됩니다.</p>
            <h2>수집 및 수신하는 정보.</h2>
            <p>소프트웨어 및 서비스를 사용할 때, 당사는 자동으로 다음 유형의 정보를 수집 및 저장할 수 있습니다:</p>
            <p>1.    기술 정보. 기기 및 소프트웨어·서비스, 기타 타사 소프트웨어(“기타 소프트웨어”) 사용에 관한 일부 기술 정보(운영체제 및 기타 소프트웨어의 유형/이름/버전, 상호작용, ISP, 위치(GPS), IP 주소, 익명 사용자 식별자, 기기 구성 및 식별자(IDFA, Advertising ID 등), 소프트웨어·서비스 버전, 구성 및 설정 등).</p>
            <p>2.    사용 정보. 기기와 소프트웨어·서비스 및 기타 소프트웨어의 사용과 상호작용에 관한 정보(어플리케이션 설치·사용 현황 및 빈도, 광고 조회/사용/접근 및 반응 등).</p>
            <p>3.    소셜 네트워크. 소프트웨어·서비스를 통한 소셜 네트워크 상의 상호작용;</p>`,
            section2: `        <p>4.    등록 관련 정보. (해당 시) 이름, 주소, 이메일, 전화/팩스 번호, 생년월일, 성별 등 등록 시 제공 정보;</p>
            <p>5.    지원 관련 정보. 지원 섹션 또는 이메일로 소통 시 이메일 주소, 이름 및 자발적으로 제출한 정보를 수집할 수 있습니다. 소프트웨어·서비스 사용 시 익명의 내부 사용자 ID(“사용자 ID”)를 생성하며, 상기 정보와 결합될 수 있습니다.</p>
            <p>6.    기기 정보</p>
            <p>하드웨어 모델, OS 및 버전, 고유 기기 식별자(SSAAD, GAID 포함), 브라우저 유형 및 언어, 휴대전화 번호, 모바일 네트워크 정보, IMEI, IDFA, IDFV, ICCID, MAC 주소, 모델 및 해상도 등을 수집합니다. 이는 제품 및 서비스 사용 기기 수 산정, 기기 모델 및 그래픽 적응 데이터 분석에 사용됩니다. 일부 정보를 제공하지 않으면 앱의 많은 기능을 활용하지 못할 수 있습니다. 또한 충돌 등 문제 진단을 위해 일부 기기 정보를 수집합니다.</p>
            <p>7. 카메라 및 사진</p>
            <p>일부 서비스는 기기의 카메라 및 사진에서 이미지를 수집해야 합니다. 동의 후에만 접근합니다. 제공하지 않으면 많은 서비스를 사용하지 못할 수 있습니다.</p>
            <p>8. 로컬 스토리지</p>
            <p>브라우저 웹 스토리지(HTML5 포함) 및 앱 데이터 캐시 등의 메커니즘을 사용하여 로컬에 정보를 수집·저장할 수 있습니다. 저장 정보는 제3자와 공유되지 않습니다.</p>
            <p>9.  비개인정보</p>`,
            section3: `        <p>    비개인정보는 특정 개인을 직접 식별할 수 없는 형태의 데이터(Android ID, CPN 모델, 메모리 크기, 전화 IMEI, 전화 모델, 롬, 설치된 앱 이름/패키지명, 통신사, 위치, 설치/삭제, 사용 빈도 등)입니다.</p>
            <p>    사용자 행동 이해, 문제 해결, 제품·서비스·광고 개선을 위해 비개인정보(설치 앱명/패키지명, 설치 데이터, 사용 빈도, 국가, 장비, 채널 등)를 수집·사용할 수 있습니다.</p>
            <h2>정보 사용 목적</h2>
            <p>팀은 다음의 분석, 비즈니스, 운영 목적을 위해 정보를 사용할 수 있습니다:</p>
            <p>1.    소프트웨어·서비스 운영 및 업데이트, 기존·신규 기능 제공;</p>
            <p>2.    소프트웨어·서비스 개선 및 맞춤화;</p>
            <p>3.    맞춤형 콘텐츠 제공(자사 또는 파트너의 관심 기반 광고 포함);</p>
            <p>4.    품질 및 운영 유지·개선;</p>
            <p>5.    업데이트 알림;</p>
            <p>6.    지원 제공 및 불만/피드백 처리;</p>
            <p>7.    분쟁 발생 시 조치;</p>`,
            section4: `        <p>8.    약관 집행 및 불법 활동/오용 방지;</p>
            <p>9.    관련 법규, 법적 절차 또는 정부 요구 준수. 제3자와의 정보 공유.</p>
            <h2>아동의 개인정보</h2>
            <p>본 서비스는 13세 미만을 대상으로 하지 않습니다. 13세 미만 아동의 정보가 수집된 것을 인지하면 즉시 삭제합니다. 부모/보호자인 경우 자녀의 정보 제공을 알게 되면 연락해 주십시오.</p>
            <h2>개인정보 처리방침 변경</h2>
            <p>수시로 업데이트될 수 있으므로 정기적으로 확인하십시오. 변경 사항은 본 페이지에 게시되며 게시 즉시 효력이 발생합니다.</p>
            <h2>문의하기</h2>
            <p>개인정보 처리방침에 관한 문의는 Email: watch_support@adflash.cn 로 연락하십시오</p>`,


        },
        refund: {
            section1: `<p>구매해 주셔서 감사합니다. 구매에 완전히 만족하지 못하신 경우 도와드리겠습니다.</p>
            <p>환불을 시작하려면 아래 절차를 따르십시오.</p>
            <p>구독 상품(예: 베이식 구독)</p>
            <p>사용을 중단했으나 구독을 취소하지 않은 경우, 결제 후 세션 사용이나 이미지 생성이 없었다면 보통 최근 결제 금액을 환불해 드립니다.</p>
            <p>환불을 요청하려면 계정 및 피드백 양식을 통해 환불 요청을 보내주세요. 신원 확인을 위해 추가 정보가 필요할 수 있습니다.</p>
            <p>디지털 상품(예: 횟수 팩, 구독)</p>
            <p>횟수 팩 및 구독을 사용한 경우 환불되지 않습니다. 부분/일할 환불은 제공하지 않습니다.</p>
            <p>거래일로부터 14일 이내에 환불을 요청할 수 있습니다.</p>
            <p>환불 요청을 받으면, 직원이 멤버십 상태를 확인하여 환불 자격을 판단합니다.</p>`,
            section2: `<p>승인되면 환불이 처리됩니다. 환불 금액은 구매 시 사용한 원래 [결제 수단]으로 지급됩니다.</p>
            <p>환불 지연 또는 미수령</p>
            <p>환불을 받지 못한 경우, 먼저 은행 계좌를 다시 확인하세요.</p>
            <p>그 다음 카드사에 문의하세요. 환불이 공식 반영되기까지 시간이 걸릴 수 있습니다.</p>
            <p>다음으로 은행에 문의하세요. 환불 반영 전 처리 시간이 필요합니다.</p>
            <p>이 모든 과정을 거쳤음에도 환불이 없으면 watch_support@adflash.cn으로 연락하세요.</p>
            <p>세일 상품</p>
            <p>정가 상품만 환불 가능하며, 세일 상품은 환불되지 않습니다.</p>`,
        },
        us: {
            section1: `<p>회사 정보</p>
            <p>이름: HONG KONG ADFLASH MEDIA LIMITED</p>
            <p>주소: RM 1101 11/F SAN TOI BUILDING NO.139 CONNAUGHT ROAD CENTRAL HK</p>
            <p>이메일: watch_support@adflash.cn</p>`,
        },
        zhznService: {
            section1: `<h1>서비스 약관</h1>
    마지막 업데이트: 2024년 6월 12일<br>
    본 서비스를 사용하기 전에 본 서비스 약관을 주의 깊게 읽어주십시오. <br>
`,
            section2: `<h1>해석 및 정의</h1>
    <h1>해석</h1>
    대문자로 시작하는 단어는 아래 조건에 따라 정의된 의미를 갖습니다.
    단수/복수 여부와 관계없이 동일한 의미를 가집니다.
    <br>`,
            section3: `    <h1>정의</h1>
    본 약관의 목적상:
    - 애플리케이션: 회사가 제공하며 귀하가 전자기기에서 사용하는 소프트웨어 프로그램. <br>
    - 계정: 서비스 또는 그 일부에 접근하기 위해 생성된 고유 계정.<br>
    - 회사(“회사”, “당사”, “우리”): HONG KONG ADFLASH MEDIA LIMITED를 의미.<br>
    - 콘텐츠: 귀하가 게시, 업로드, 링크 또는 기타 방식으로 이용 가능하게 하는 텍스트, 이미지 등.<br>
    - 기기: 시계, 휴대전화, 태블릿 등 서비스에 접근 가능한 모든 기기.<br>
    - 피드백: 서비스의 속성, 성능 또는 기능에 관한 귀하의 의견, 혁신 또는 제안.<br>
    - 상품: 서비스에서 판매되는 품목.<br>
    - 주문: 당사로부터 상품 구매를 요청하는 행위.<br>
    - 서비스: 애플리케이션을 의미.<br>
    - 구독: 회사가 제공하는 구독 기반 서비스 또는 접근 권한.<br>
    - 무료 체험: 구독 구매 시 무상 제공될 수 있는 제한된 기간.<br>
    - 약관: 본 서비스 이용에 관한 귀하와 회사 간의 전체 합의를 구성하는 본 약관.<br>
    - 귀하: 서비스를 이용하는 개인 또는 그를 대표하는 법인 등.<br>`,
            section4: `<h1>승인</h1>
    본 약관은 서비스 사용을 규율하며 귀하와 회사 간의 합의입니다. 본 약관은 모든 사용자의 권리와 의무를 규정합니다. <br>
    서비스 접근 및 사용은 본 약관의 수락 및 준수를 조건으로 합니다. 본 약관은 모든 방문자, 사용자에게 적용됩니다.<br>
    서비스 접근 및 사용은 회사의 개인정보 처리방침 수락 및 준수도 조건입니다. 개인정보 처리방침은 애플리케이션/웹사이트 사용 시 개인정보의 수집, 이용 및 공개에 관한 정책을 설명합니다. 이용 전 반드시 읽어주세요.<br>`,
            section5: `    <h1>서비스 내용</h1>
    원활한 이용을 위해 다음 이용자 약관을 주의 깊게 읽고 준수해 주십시오. <br>
    <h2>1. 서비스 중단 면책</h2>
    a. 일부 기능은 OPENAI 서비스에 의존합니다. OPENAI의 시스템 중단 등으로 서비스 경험이 영향을 받을 수 있으며, 해결을 위해 최선을 다하지만 직접적 책임은 지지 않습니다. <br>
    b. 본 앱은 사용자의 위치 법령을 준수합니다. 법령 변경으로 서비스 제공이 불가할 경우 신속히 조정하나 이에 대한 책임은 부담하지 않습니다. <br>
    c.  3. 당사는 일정 횟수의 무료 사용을 제공합니다. 사용자가 부족하다고 판단해도 이는 AI 서비스의 기존 무료 제공 정책임을 양해 바랍니다. <br>
    <h2>2. 네트워크 연결 문제</h2>
    안정적인 네트워크와 적절한 하드웨어 성능을 권장합니다. 일부 기능은 빠르고 안정적인 인터넷 연결과 충분한 전송 속도에 의존합니다. 불안정한 네트워크, 전송 지연, 일시적 단절로 인한 불편에 책임지지 않습니다. <br>
    <h2>3. 앱 서비스 및 네트워크 문제</h2>
    a. 기술적 등 통제 불가 요인으로 일시적 중단이 있을 수 있습니다. 신고 후 신속 복구를 위해 지원합니다. <br>
    b. 네트워크 변동, 설정 오류로 기기와의 연결이 끊길 수 있습니다. 올바른 페어링과 안정적 네트워크를 권장합니다. 가이드와 온라인 지원을 제공하지만, 제3자 요인으로 인한 중단에 대해서는 책임을 지지 않습니다. <br>
    c.   3. 앱은 안정적인 인터넷 연결이 필요합니다. 네트워크 문제 시 고객 지원을 통해 개선을 도와드립니다. <br>
    <h2>4. 음성 인식률 기대 차이</h2>
    음성 인식 기술은 엄격히 테스트되었지만, 기술적 한계 등으로 인식률이나 결과가 기대에 못 미칠 수 있습니다. 결과에 만족하지 못할 경우 개선을 위해 노력하나 결과에 대한 책임은 지지 않습니다. <br>
    문의 또는 기술 지원이 필요하시면 고객센터로 연락하세요 <br>
    이메일: aisupport@adflash.cn <br>`,
            section6: `<h1>주문</h1>
    서비스에서 상품을 주문함으로써, 귀하는 법적으로 구속력 있는 계약을 체결할 능력이 있음을 보증합니다. <br>`,
            section7: `<h1>귀하의 정보</h1>
    주문 시 카드 번호, 유효기간, 청구 주소, 배송 정보 등 관련 정보를 요청할 수 있습니다.
    <br>
    (i) 해당 결제 수단을 사용할 권리가 있고, (ii) 제공 정보가 진실·정확·완전함을 진술·보증합니다. <br>
    정보를 제출함으로써 결제 처리를 위해 제3자 결제사에 정보를 제공하는 것에 동의합니다. <br>`,
            section8: `<h1>주문 취소</h1>
    다음 사유 등으로 언제든지 주문을 거부 또는 취소할 수 있습니다: <br>
    - 상품 가용성 <br>
    - 상품 설명 또는 가격 오류 <br>
    - 주문 내 오류 <br>
    사기 또는 무단/불법 거래가 의심되는 경우 주문을 거부 또는 취소할 수 있습니다. <br>`,
            section9: `<h1>가용성, 오류 및 부정확성</h1>
    당사는 지속적으로 상품 제공을 업데이트합니다. 서비스의 상품이 오표기, 부정확한 설명, 품절일 수 있으며, 정보 업데이트에 지연이 있을 수 있습니다. <br>
    가격, 이미지, 사양, 가용성, 서비스 등 정보의 정확성 또는 완전성을 보장하지 않습니다. 사전 통지 없이 정보를 변경·업데이트하고 오류를 정정할 권리를 보유합니다. <br>`,
            section10: `<h1>가격 정책</h1>
    회사는 주문 수락 전 언제든 가격을 수정할 권리를 보유합니다. <br>
    주문 수락 후에도 정부 조치, 관세 변동, 운송비 인상, 환율 상승 등 통제 불가 사유로 가격이 변경될 수 있으며, 이 경우 주문을 취소할 권리가 있습니다. <br>`,
            section11: `<h1>결제</h1>
    모든 상품은 일회성 결제입니다. Visa, MasterCard, 온라인 결제(PayPal 등) 등 제공되는 방법으로 결제할 수 있습니다. <br>
    결제 카드는 발급사의 유효성 검사 및 승인을 받아야 합니다. 승인을 받지 못하면 지연 또는 미배송에 대해 당사는 책임지지 않습니다. <br>`,
            section12: `<h1>구독</h1>
    <h1>구독 기간</h1>
    서비스의 전부 또는 일부는 유료 구독으로만 이용 가능합니다. 선택한 구독 유형에 따라 선결제로 반복 청구됩니다(일/주/월/년 등). <br>
    각 기간 종료 시, 귀하 또는 회사가 취소하지 않는 한 동일 조건으로 자동 갱신됩니다. <br>`,
            section13: `<h1>환불</h1>
    법률상 요구되는 경우를 제외하고, 구독료는 환불되지 않습니다. <br>
    특정 환불 요청은 개별적으로 검토되며 회사의 단독 재량으로 승인될 수 있습니다. <br>`,
            section14: ` <h1>결제 약관</h1>
    원활한 결제와 투명한 서비스 제공을 위해 다음을 주의 깊게 읽어주세요. <br>
    1. 결제 진행을 위해 안정적 네트워크와 하드웨어 상태를 사용자가 보장해야 합니다. 사용자 측 네트워크/하드웨어 문제로 인한 결제 실패에 대해 당사는 책임지지 않습니다. <br>
    2. 카드사 위험관리로 결제가 실패할 수 있으며, 이 경우 당사는 책임지지 않습니다. 결제 전 발급사에 사용 상태와 제한을 확인하시기 바랍니다. <br>
    3. 결제 기능은 제3자 플랫폼에 의존할 수 있습니다. 제3자 장애로 인한 결제 실패 시, 당사는 소통·지원에 최선을 다하나 책임지지 않습니다. 문제 발생 시 언제든 고객센터에 문의하세요. <br>
    4. 사용자가 월 구독을 자발적으로 선택·확정한 후에는 사용자 센터에서 구독 상태와 이용 내역을 조회·관리할 수 있습니다. 개인 선택에 따른 주기적 청구에 대한 불만은 책임지지 않습니다. <br>
    5. 구매 후 서비스 사용이 시작되면, 일반적으로 환불은 불가합니다. 구매 전 약관을 주의 깊게 읽고 문의사항은 고객센터에 확인해 주세요. <br>
    6. 관련 법령 또는 규제 조치로 인한 결제 실패의 경우, 당사는 관련 정보를 제공하고 해결을 지원하나, 최종 책임은 현지 법령 준수에 있습니다. <br>
    문의:  <br>
    - 이메일: aisupport@adflash.cn <br>`,
            section15: `<h1>사용자 계정</h1>
    계정 생성 시 항상 정확하고 완전하며 최신 정보를 제공해야 합니다. 미준수 시 즉시 계정이 종료될 수 있습니다. <br>
    비밀번호 보호와 비밀번호로 수행되는 모든 활동에 대한 책임은 귀하에게 있습니다. <br>
    비밀번호를 제3자와 공유하지 마십시오. 보안 침해나 무단 사용을 인지하면 즉시 통지해야 합니다. <br>
    사용자명은 타인의 이름/권리 침해/불쾌·외설적 명칭을 사용할 수 없습니다. <br>`,
            section16: `<h1>저작권 정책</h1>
    <h1>지식재산권 침해</h1>
    당사는 타인의 지식재산을 존중합니다. 서비스에 게시된 콘텐츠가 저작권 등을 침해한다는 청구에 대응하는 정책을 보유합니다. <br>
    저작권자 또는 대리인이라면, 침해 세부사항을 포함한 서면 통지를 저작권 담당자에게 제출해야 합니다. <br>
    침해를 허위로 주장할 경우 손해배상 책임이 발생할 수 있습니다. <br>`,
            section17: `<h1>DMCA 통지 및 절차</h1>
    DMCA에 따라 다음 정보를 포함한 서면 통지를 저작권 담당자에게 제출할 수 있습니다(17 U.S.C 512(c)(3)): <br>
    - 권리자 대리의 전자/물리 서명 <br>
    - 침해 주장 저작물의 설명 및 URL 또는 사본 <br>
    - 침해 자료가 위치한 서비스상의 URL 또는 위치 <br>
    - 주소, 전화번호, 이메일 <br>
    - 사용이 권리자/대리인/법에 의해 허용되지 않는다는 선의의 진술 <br>
    - 위증 시 처벌을 감수하고, 진술이 정확하며 권리자이거나 대리인이라는 진술 <br>
    저작권 담당자 이메일: aisupport@adflash.cn <br>
    통지 수령 후, 회사는 재량에 따라 해당 콘텐츠를 제거하는 등 조치를 취합니다. <br>`,
            section18: `<h1>지식재산</h1>
    서비스 및 원본 콘텐츠(귀하 또는 다른 사용자 제공 제외), 기능은 회사와 라이선스 제공자의 독점 자산입니다. <br>
    서비스는 국내외 저작권, 상표 등 법률의 보호를 받습니다. <br>
    상표 및 트레이드 드레스는 회사의 사전 서면 동의 없이 사용할 수 없습니다. <br>`,
            section19: `<h1>피드백</h1>
    귀하는 제공한 피드백에 대한 모든 권리를 회사에 양도합니다. 양도가 무효인 경우, 회사에 전 세계적, 영구적, 철회 불가, 로열티 프리의 사용·복제·공개·서브라이선스·배포·수정·활용 권한을 부여합니다. <br>`,
            section20: `<h1>종료</h1>
    귀하가 본 약관을 위반하는 등 어떠한 사유로든 사전 통지 없이 계정을 즉시 종료 또는 정지할 수 있습니다. <br>
    종료 시 서비스 이용 권리는 즉시 중지됩니다. 계정을 종료하려면 단순히 사용을 중단하면 됩니다. <br>`,
            section21: `<h1>책임의 제한</h1>
    발생 가능한 모든 손해와 무관하게, 회사 및 공급자의 전체 책임과 배타적 구제는 서비스 통해 실제 지불한 금액(또는 미구매 시 0)으로 제한됩니다. <br>
    법이 허용하는 최대 범위 내에서, 회사 또는 공급자는 특수, 우발, 간접, 결과적 손해(이익·데이터 손실, 업무 중단, 개인정보 침해 등)에 대해 책임지지 않습니다. <br>
    일부 주에서는 묵시적 보증의 배제 또는 결과적 손해 책임 제한을 허용하지 않으므로 일부 제한이 적용되지 않을 수 있습니다. <br>`,
            section22: `<h1>“있는 그대로” 면책</h1>
    서비스는 모든 결함을 포함한 “있는 그대로” 및 “가용한 상태로” 제공됩니다. 회사 및 계열사, 라이선스 제공자는 상품성, 특정 목적 적합성, 소유권, 비침해, 거래 관행에 따른 보증 등 모든 보증을 부인합니다. 서비스가 요구 사항을 충족하거나, 중단 없이 작동하거나, 오류가 없거나, 오류가 수정될 것이라는 보증을 하지 않습니다. <br>
    또한 (i) 서비스의 운영·가용성, 정보·콘텐츠·자료·제품에 대한 보증, (ii) 서비스의 중단/무오류, (iii) 정보의 정확성·신뢰성·최신성, (iv) 서비스·서버·콘텐츠·이메일이 바이러스/악성코드로부터 안전함을 보증하지 않습니다. <br>
    일부 관할권에서는 특정 보증의 배제 또는 소비자의 법정 권리에 대한 제한을 허용하지 않으므로 일부 또는 전부가 적용되지 않을 수 있습니다. 그 경우 허용되는 최대 범위로 적용됩니다. <br>`,
            section23: ` <h1>준거법</h1>
    충돌법 규정을 제외한 해당 국가의 법률이 본 약관 및 서비스 사용을 규율합니다. 애플리케이션 사용은 다른 지역 법률의 적용을 받을 수 있습니다. <br>`,
            section24: `<h1>분쟁 해결</h1>
    서비스와 관련된 우려 또는 분쟁이 있는 경우, 먼저 회사에 연락하여 비공식적으로 해결을 시도하기로 동의합니다. <br>`,
            section25: ` <h1>EU 사용자</h1>
    EU 소비자는 거주 국가의 강행 규정의 보호를 받습니다. <br>`,
            section26: `<h1>미 연방 정부 최종 사용자 조항</h1>
    귀하가 미 연방 정부 최종 사용자라면, 본 서비스는 48 C.F.R. 2.101에 정의된 “상용 항목”입니다. <br>`,
            section27: `<h1>미국 법률 준수</h1>
    귀하는 (i) 미국 정부의 금수 대상국 또는 테러 지원국에 위치하지 않으며, (ii) 미국 정부의 제재 대상 목록에 등재되어 있지 않음을 진술·보증합니다. <br>`,
            section28: `<h1>분리가능성 및 권리 불행사</h1>
    <h1>분리가능성</h1>
    조항이 집행 불능 또는 무효인 경우, 목적을 최대한 달성하도록 변경·해석되며 나머지 조항은 계속 유효합니다. <br>`,
            section29: `<h1>권리 불행사</h1>
    본 약관에 따른 권리 행사 또는 의무 이행 요구의 부재는 향후 해당 권리 행사 또는 요구를 방해하지 않으며, 위반에 대한 포기는 이후 위반의 포기가 아닙니다. <br>`,
            section30: `<h1>번역 해석</h1>
    본 약관이 번역되어 제공될 수 있습니다. <br>
분쟁 시 원문 영어가 우선합니다. <br>`,
            section31: `<h1>약관 변경</h1>
당사는 재량으로 언제든 본 약관을 수정 또는 대체할 수 있습니다. 중대한 변경 시 발효 최소 30일 전 합리적으로 통지합니다. 중대 변경의 판단은 당사의 재량입니다. <br>
변경 발효 후 계속 사용 시 수정된 약관에 동의한 것으로 간주됩니다. 동의하지 않으면 서비스를 중단하십시오. <br>`,
            section32: `<h1>문의</h1>
본 약관에 대한 질문은 다음으로 연락하십시오: <br>
- 이메일: aisupport@adflash.cn`
        },
        zhznPrivacy: {
            section1: ` <h2>개인정보 처리방침</h2>
                <p>귀하의 개인정보 보호는 중요합니다. 인터넷을 통해 제공될 수 있는 개인 식별 정보를 당사가 어떻게 처리하는지 설명합니다.</p>
                <p>당사 앱 및 관련 서비스를 기반으로 특수 기능 서비스를 신청할 수 있습니다. 해당 서비스 이용 전 해당 서비스 약관을 주의 깊게 읽으십시오.  </p>
                <p>특수 기능 서비스를 수락 또는 사용함으로써, 본 약관과 해당 서비스 약관을 읽고 동의하며 구속됨에 동의합니다.</p>
                <p>요청하신 서비스를 제공하기 위해 때때로 정보가 필요할 수 있습니다. 본 방침은 해당 제품에 적용됩니다.</p>`,
            section2: `<h2>수집 및 수신 정보</h2>
                <p>소프트웨어 및 서비스를 사용할 때, 당사는 다음 정보를 자동으로 수집·저장할 수 있습니다:</p>
                <p>안전한 운영, 품질 및 효율을 위해, 시스템 버전, 기기 식별자(Android: AndroidID, iOS: VendorID 등), 네트워크 장치 MAC 주소, 해상도 등을 필요에 따라 수집할 수 있습니다.</p>
                <p>악성 프로그램 방지와 운영 효율을 위해, 실행 프로세스, 페이지 전반 동작, 사용 빈도, 페이지 크래시, 전체 사용량, 성능 데이터를 수집합니다.</p>`,
            section3: `<h2>정보 사용 목적</h2>
        
                <p>팀은 다음과 같은 분석, 비즈니스, 운영 목적으로 정보를 사용할 수 있습니다:</p>
                <p>- 소프트웨어·서비스 운영 및 업데이트, 기존/신규 기능 제공;</p>
                <p>- 소프트웨어·서비스 개선 및 맞춤화;</p>
                <p>- 개인화된 콘텐츠 제공;</p>
                <p>- 품질 및 운영의 유지·개선;</p>
                <p>- 업데이트 알림;</p>
                <p>- 지원 제공 및 불만/피드백 처리;</p>
                <p>- 분쟁 발생 시 조치;</p>
                <p>- 약관 집행 및 불법 활동/오용 방지;</p>
                <p>- 관련 법규, 법적 절차 또는 정부 요구 준수. 제3자와의 정보 공유.</p>

                <p>당사는 귀하의 개인정보 보안을 위해 최선을 다하며, 제품 및 서비스 제공에 필요한 기간 동안만 보유합니다. 예:</p>
                <p>- MAC 주소: 정상 서비스 제공, 문의/불만 대응, 계정·시스템 보안을 위해 지속 보유 필요.</p>
                <p>- 구독 결제 관련 토큰: 관련 구독 서비스 제공을 위함.</p>
                <p>- 법령상 보관 요구 준수.</p>
                <p>- 재무, 감사, 분쟁 해결 등을 위한 합리적 기간 연장.</p>`,
            section4: `<h2>아동의 개인정보</h2>

                <p>아동의 개인정보를 고의로 수집하지 않습니다. 아동의 개인정보 제공을 인지하면 즉시 서버에서 삭제합니다. 부모/보호자인 경우 연락해 주십시오.</p>`,
            section5: `<h2>방침 변경</h2>
                
                <p>본 방침은 수시로 업데이트될 수 있습니다. 정기적으로 확인해 주십시오. 변경 사항은 본 페이지에 게시되며, 게시 즉시 효력이 발생합니다.</p>`,
            section6: ` <h2>방침 변경</h2>
                
                <p>본 방침은 수시로 업데이트될 수 있습니다. 정기적으로 확인해 주십시오. 변경 사항은 본 페이지에 게시되며, 게시 즉시 효력이 발생합니다.</p>`,
            section7: `<h2>문의</h2>

                <p>본 방침에 관한 질문이나 제안이 있으면 다음으로 연락해 주세요:</p>
                <p>aisupport@adflash.cn</p>`
        }
    }
}
